import './bootstrap';
import {Alpine, Livewire} from '../../vendor/livewire/livewire/dist/livewire.esm';
import '@nextapps-be/livewire-sortablejs';
import Tooltip from "@ryangjchandler/alpine-tooltip";
import 'quill/dist/quill.js';
import Clipboard from "@ryangjchandler/alpine-clipboard";
import onPageNavigation from "./alpine-components/on-page-navigation";
import audioPlayer from "./alpine-components/audio-player";
import header from "./alpine-components/header";
import fileUpload from "./alpine-components/file-upload";
import Swiper from "swiper";
import {Pagination} from "swiper/modules";
import Wysiwyg from "./alpine-components/wysiwyg";

window.HELP_IMPROVE_VIDEOJS = false;

Alpine.plugin(Tooltip);
Alpine.plugin(Clipboard);

Alpine.data('onPageNavigation', onPageNavigation);
Alpine.data('audioPlayer', audioPlayer);
Alpine.data('header', header);
Alpine.data('fileUpload', fileUpload);
Alpine.data('wysiwyg', Wysiwyg);

Livewire.start();

document.addEventListener('livewire:navigated', () => {
    document.querySelectorAll(".church-year-day-dates-slider").forEach((slider) => {
        new Swiper(slider, {
            modules: [Pagination],
            initialSlide: parseInt(slider.dataset.initialSlide, 10) || 0,
            spaceBetween: 12,
            slidesPerView: 2,
            breakpoints: {
                480: {
                    slidesPerView: 3,
                },
                760: {
                    slidesPerView: 4,
                },
            },
        });
    });
});
